import { render, staticRenderFns } from "./ReportisticaDaFatturare.vue?vue&type=template&id=05ed5ca4"
import script from "./ReportisticaDaFatturare.vue?vue&type=script&lang=js"
export * from "./ReportisticaDaFatturare.vue?vue&type=script&lang=js"
import style0 from "./ReportisticaDaFatturare.vue?vue&type=style&index=0&id=05ed5ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports